import { useContext } from 'react';
import { WidgetEnvironmentContext } from './EnvironmentProvider';
export var useEnvironment = function () {
    var context = useContext(WidgetEnvironmentContext);
    if (!context) {
        throw new Error("`useEnvironment()` can't be used within a `Settings` component. Please use `useSettingsEnvironment()`");
    }
    return context;
};
//# sourceMappingURL=useEnvironment.js.map